module.exports = __webpack_public_path__ + "static/img/banner001.058d117.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/financialAudit/banner001.png
// module id = A9bg
// module chunks = 1